// Create a single Geocoder instance
import Cookies from 'js-cookie';
import DOMPurify from 'dompurify';
let geocoder = new window.google.maps.Geocoder();
const msgEl = document.getElementById('root')?.getAttribute('data-message-json');
const messages = msgEl ? JSON.parse(msgEl) : {};
const utilEl = document.getElementById('utility-bar-root')?.getAttribute('data-message-json');
const utilityMessages = utilEl ? JSON.parse(utilEl) : {};
const basEl = document.getElementById('bas-root')?.getAttribute('data-message-json');
const basMessages = basEl ? JSON.parse(basEl) : {};
const provinceEl = document.getElementById('utility-bar-root')?.getAttribute('data-province-list');
const provinceMapping = provinceEl ? JSON.parse(provinceEl) : {};
const bnoSettingsEl = document.getElementById('root')?.getAttribute('data-bno-settings-json');
const bnoSettings = bnoSettingsEl ? JSON.parse(bnoSettingsEl) : {};
const imageNotAvailableLargeUrl = bnoSettings.imageNotAvailableLargeUrl || '';
const imageNotAvailableSmallUrl = bnoSettings.imageNotAvailableSmallUrl || '';
const dealerImgNotAvailableUrl = bnoSettings.dealerShipFallbackImageUrl || '';
const numberOfDealers = bnoSettings.numberOfDealers || '3';
const limitedServicesKmRange = bnoSettings.limitedServicesKmRange || '50';
const stepperEl = document.getElementById('root')?.getAttribute('data-step-header');
const stepperJson = stepperEl ? JSON.parse(stepperEl) : {};
const lang = Cookies.get('genesis#lang');
console.log(messages);
// Get autocomplete predictions for postal code
export function getAutocompletePredictions(postalCode, autocompleteService) {
  return new Promise(function (resolve, reject) {
    try {
      autocompleteService.getPlacePredictions(
        {
          input: postalCode,
          types: ['postal_code'],
          componentRestrictions: { country: 'CA' },
        },
        (predictions, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK) {
            const fullPostalCodes = predictions.filter((prediction) => {
              // Check if the postal code is a full code
              return !prediction.types.includes('postal_code_prefix');
            });
            resolve(fullPostalCodes);
          } else {
            reject(status);
          }
        }
      );
    } catch (err) {
      console.log(err);
    }
  });
}

export function validatePostalCode(postalCode) {
  var address = postalCode;
  let provinceName = 'default';
  let provinceCode = 'default';
  let postalCodeValue = 'default';

  return new Promise(function (resolve, reject) {
    try {
      geocoder.geocode(
        { address: address, componentRestrictions: { country: 'CA' } },
        function (results, status) {
          if (status === 'OK') {
            var formattedAddress;
            var isPostalCode = false;
            results.forEach((result) => {
              isPostalCode =
                result.types.includes('postal_code') &&
                !result.types.includes('postal_code_prefix');
              result.address_components.every(function (component) {
                if (
                  component.types.includes('postal_code') &&
                  !component.types.includes('postal_code_prefix')
                ) {
                  formattedAddress = component.long_name.replace(/ /g, '');
                  return false;
                } else return true;
              });
            });
            if (isPostalCode && formattedAddress.includes(postalCode.replace(/ /g, ''))) {
              results[0].address_components.forEach(function (component, i) {
                if (component.types.includes('administrative_area_level_1')) {
                  provinceCode = component.short_name;
                  provinceMapping.every((province) => {
                    if (province.Key === provinceCode) {
                      provinceName = province.Value;
                      return false;
                    } else {
                      return true;
                    }
                  });
                }
                if (component.types.includes('postal_code')) {
                  postalCodeValue = component.long_name.replace(/ /g, '');
                  console.log('postalCodeValue ', postalCodeValue);
                } else {
                  postalCodeValue = postalCode.replace(/ /g, '');
                }
              });
              resolve({
                isValid: true,
                provinceName,
                provinceCode,
                postalCodeValue,
              });
            } else {
              resolve({
                isValid: false,
                provinceName,
                provinceCode,
                postalCodeValue,
              });
            }
          } else {
            resolve({
              isValid: false,
              provinceName,
              provinceCode,
              postalCodeValue,
            });
          }
        }
      );
    } catch (err) {
      console.log(err);
    }
  });
}

export function getMessage(section) {
  return messages[section];
}

export function getAllLabels() {
  return messages;
}

export function getFallbackImage() {
  return imageNotAvailableSmallUrl;
}

export function getLargeFallbackImage() {
  return imageNotAvailableLargeUrl;
}

export function getDealerShipFallbackImage() {
  return dealerImgNotAvailableUrl;
}

export function getNumberOfDealers() {
  return parseInt(numberOfDealers);
}

export function getLimitedServicesKmRange() {
  return parseInt(limitedServicesKmRange);
}

export function getUtilityLabels() {
  return utilityMessages;
}

export function getBasLabels() {
  return basMessages;
}

export function getStepperLabels() {
  return stepperJson;
}

export function getProvinceMapping() {
  return provinceMapping;
}
export function displayCurrency(val) {
  if (val === 0) {
    return '-';
  }
  const centValue = (Number(val) * 100) % 100;
  if (lang === 'fr') {
    return centValue === 0
      ? `${Number(val).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} $`
      : `${Number(val).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} $`;
  }
  return centValue === 0
    ? `$${Number(val).toLocaleString('en-EN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`
    : `$${Number(val).toLocaleString('en-EN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function displayNumber(val) {
  if (lang === 'fr') {
    return `${Number(val).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
  }
  return `${Number(val).toLocaleString('en-EN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}

export function loadScript(src, integrity) {
  return new Promise((resolve, reject) => {
    // Check if the script is already included
    // if (allowedScripts.indexOf(src) === -1) reject(new Error(`Script load error for ${src}`));
    const existingScript = document.querySelector(`script[src="${src}"]`);
    if (existingScript) {
      resolve();
      return;
    }

    // Create a new script element
    const script = document.createElement('script');
    script.src = src;
    script.type = 'module';
    script.async = true;
    if (integrity) {
      script.integrity = integrity;
      script.crossOrigin = 'anonymous';
    }

    // Handle script load and error events
    script.onload = () => {
      resolve();
    };
    script.onerror = () => {
      reject(new Error(`Script load error for ${src}`));
    };

    // Append the script to the document head
    document.head.appendChild(script);
  });
}

export function sanitizedHTML(htmlString) {
  const sanitizedHTML = DOMPurify.sanitize(htmlString);
  return sanitizedHTML;
}

export function getCardPriceDesc(card) {
  let price = 0;
  let desc = '';
  if (card.subSection?.length > 0) {
    card.subSection.every((section) => {
      if (!section.selected) {
        return true;
      }
      if (!section.subSection || section.subSection?.length === 0) {
        if (section.selected) {
          price = section.price;
          desc = section.description;
          return false;
        }
      } else {
        section.selected &&
          section.subSection.every((sub) => {
            if (!sub.selected) {
              return true;
            }
            if (!sub.subSection || sub.subSection?.length === 0) {
              if (sub.selected) {
                price = sub.price;
                desc = sub.description;
                return false;
              }
            } else {
              sub.selected &&
                sub.subSection.every((third) => {
                  if (third.selected) {
                    price = third.price;
                    desc = third.description;
                    return false;
                  }
                  return true;
                });
            }
          });
      }
    });
  }
  return { price, desc };
}

export function isElementInViewport(element) {
  const rect = element.getBoundingClientRect();

  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  const visibleHeight = Math.max(0, Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0));

  return {
    isVisible:
      rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
      rect.bottom > 0 &&
      rect.left < (window.innerWidth || document.documentElement.clientWidth) &&
      rect.right > 0,
    visibleHeight: visibleHeight,
  };
}

export var isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(window.navigator.platform);

export var isIOS = /(iPhone|iPod|iPad)/i.test(window.navigator.platform);

//Get header position from top
export let windowWidth = Math.max(
  document.documentElement.clientWidth || 0,
  window.innerWidth || 0
);

export let windowHeight = Math.max(
  document.documentElement.clientHeight || 0,
  window.innerHeight || 0
);
